/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hour: NonNullable<unknown>, minute: NonNullable<unknown> }} Event_State_Time_LeftInputs */

const en_event_state_time_left = /** @type {(inputs: Event_State_Time_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ends in ${i?.hour}h ${i?.minute}m`)
};

const ar_event_state_time_left = /** @type {(inputs: Event_State_Time_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ينتهي خلال ${i?.hour} س و ${i?.minute} د`)
};

const de_event_state_time_left = /** @type {(inputs: Event_State_Time_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`endet in ${i?.hour} Std. ${i?.minute} Min.`)
};

const es_event_state_time_left = /** @type {(inputs: Event_State_Time_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`termina en ${i?.hour} h ${i?.minute} m`)
};

const fr_event_state_time_left = /** @type {(inputs: Event_State_Time_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`se termine dans ${i?.hour} h ${i?.minute} min`)
};

const it_event_state_time_left = /** @type {(inputs: Event_State_Time_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`termina tra ${i?.hour} o ${i?.minute} m`)
};

const ja_event_state_time_left = /** @type {(inputs: Event_State_Time_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`あと ${i?.hour}時間 ${i?.minute}分で終了`)
};

const ko_event_state_time_left = /** @type {(inputs: Event_State_Time_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour}시간  ${i?.minute}분 후 종료`)
};

const pt_br_event_state_time_left = /** @type {(inputs: Event_State_Time_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`termina em ${i?.hour} h ${i?.minute} min`)
};

const ru_event_state_time_left = /** @type {(inputs: Event_State_Time_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`закончится через ${i?.hour} ч. ${i?.minute} мин.`)
};

const th_event_state_time_left = /** @type {(inputs: Event_State_Time_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`สิ้นสุดในอีก ${i?.hour} ชม. ${i?.minute} นาที`)
};

const tr_event_state_time_left = /** @type {(inputs: Event_State_Time_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour} sa ${i?.minute} dk içinde bitiyor`)
};

const zh_cn_event_state_time_left = /** @type {(inputs: Event_State_Time_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour} 小时 ${i?.minute} 分后结束`)
};

const zh_tw_event_state_time_left = /** @type {(inputs: Event_State_Time_LeftInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour} 時 ${i?.minute} 分後結束`)
};

/**
* | output |
* | --- |
* | "ends in {hour}h {minute}m" |
*
* @param {Event_State_Time_LeftInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const event_state_time_left = /** @type {((inputs: Event_State_Time_LeftInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_State_Time_LeftInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_event_state_time_left(inputs)
	if (locale === "ar") return ar_event_state_time_left(inputs)
	if (locale === "de") return de_event_state_time_left(inputs)
	if (locale === "es") return es_event_state_time_left(inputs)
	if (locale === "fr") return fr_event_state_time_left(inputs)
	if (locale === "it") return it_event_state_time_left(inputs)
	if (locale === "ja") return ja_event_state_time_left(inputs)
	if (locale === "ko") return ko_event_state_time_left(inputs)
	if (locale === "pt_br") return pt_br_event_state_time_left(inputs)
	if (locale === "ru") return ru_event_state_time_left(inputs)
	if (locale === "th") return th_event_state_time_left(inputs)
	if (locale === "tr") return tr_event_state_time_left(inputs)
	if (locale === "zh_cn") return zh_cn_event_state_time_left(inputs)
	return zh_tw_event_state_time_left(inputs)
});